<template>
  <div>
    <v-dialog v-model="show" max-width="600px">
      <v-card>
        <div class="sticky-header">
          <v-sheet class="px-0 py-4 blue darken-2">
            <div
              class="d-flex justify-space-between"
            >
              <v-card-title class="white--text">Categories</v-card-title>
              <v-btn
                class="mx-4"
                icon
                small
                @click="show = false"
              >
                <v-icon class="white--text">mdi-close</v-icon>
              </v-btn>
            </div>
            <div class="px-4">
              <v-text-field
                v-model="search"
                label="Search"
                :append-icon="!search ? 'mdi-magnify' : null"
                dark
                flat
                solo-inverted
                hide-details
                clearable
                clear-icon="mdi-close-circle-outline"
              ></v-text-field>
            </div>
          </v-sheet>
        </div>
        <v-card-text class="pl-4 pr-0 pb-0">
          <v-treeview
            :items="categoriesTree"
            item-text="Name"
            item-children="Subcategories"
            item-key="Item_Key"
            :search="search"
            dense
            open-on-click
            return-object
            hoverable
          >
            <template v-slot:append="{ item, open }">
              <v-tooltip
                bottom
                color="success"
                v-if="item.Category && item.Item_ID"
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                    v-show="!editingItem || editingItem.Item_Key !== item.Item_Key"
                    :disabled="ifSomeModesOn"
                    small
                    v-bind="attrs"
                    v-on="on"
                    icon
                    color="success"
                    @click="addNewSubcategory(item, open, $event)"
                  >
                    <v-icon>mdi-plus-circle</v-icon>
                  </v-btn>
                </template>
                <span>Add new</span>
              </v-tooltip>
              <v-tooltip bottom color="primary">
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                    v-show="!editingItem || editingItem.Item_Key !== item.Item_Key"
                    :disabled="ifSomeModesOn"
                    small
                    v-bind="attrs"
                    v-on="on"
                    icon color="primary"
                    @click.stop="editCategory(item)"
                  >
                    <v-icon>mdi-pencil-circle</v-icon>
                  </v-btn>
                </template>
                <span>Edit</span>
              </v-tooltip>
              <v-tooltip bottom color="red darken-2">
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                    v-show="!editingItem || editingItem.Item_Key !== item.Item_Key"
                    :disabled="ifSomeModesOn"
                    small
                    v-bind="attrs"
                    v-on="on"
                    icon color="red darken-2"
                    @click.stop=" showDeleteCategoryDialog(item)"
                  >
                    <v-icon>mdi-delete-circle</v-icon>
                  </v-btn>
                </template>
                <span>Delete</span>
              </v-tooltip>
              <v-tooltip bottom color="success">
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                    v-show="(modes.edit || modes.add) && editingItem && editingItem.Item_Key === item.Item_Key"
                    :disabled="(modes.add || modes.edit) && !item.Name"
                    small
                    v-bind="attrs"
                    v-on="on"
                    icon color="success"
                    @click.stop="saveItem(item)"
                  >
                    <v-icon>mdi-check-circle</v-icon>
                  </v-btn>
                </template>
                <span>Save</span>
              </v-tooltip>
              <v-tooltip bottom color="primary">
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                    v-show="(modes.edit || modes.add) && editingItem && editingItem.Item_Key === item.Item_Key"
                    small
                    v-bind="attrs"
                    v-on="on"
                    icon color="primary"
                    @click.stop="cancelEditing"
                  >
                    <v-icon>mdi-close-circle</v-icon>
                  </v-btn>
                </template>
                <span>Cancel</span>
              </v-tooltip>
            </template>
            <template v-slot:label="{ item }">
              <div>
                <span v-if="editingItem === item">
                  <v-text-field
                    v-model="item.Name"
                    autofocus
                    :rules="rules.required"
                    @keyup.enter="saveItem(item)"
                  >
                  </v-text-field>
                </span>
                <span v-else>{{ item.Name }}</span>
              </div>
            </template>
          </v-treeview>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions class="sticky-bottom pa-3">
          <v-spacer></v-spacer>
          <v-btn
            :disabled="ifSomeModesOn"
            color="success"
            small
            @click="addNewCategory"
          >
            Add Category
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <ConfirmOrDeniedDialog
      v-if="deleteAssetCategoryDialog"
      v-model="deleteAssetCategoryDialog"
      :mode="confirmOrDeniedDialogModes.delete"
      @onDeleteClick="deleteAssetCategory"
      @onCancelClick="cancelDeleting"
      @onCloseClick="cancelDeleting"
    />
  </div>
</template>

<script>
export default {
  name: 'AssetCategoriesManagerNew',
  components: {
    ConfirmOrDeniedDialog: () => import('@/components/global/ConfirmOrDeniedDialog.vue')
  },
  props: {
    value: {
      type: Boolean,
      required: false,
      default: false
    }
  },
  data () {
    return {
      caseSensitive: false,
      addCategory: true,
      addSubcategory: true,
      beforeModifiedItemCopy: null,
      categoriesTree: [],
      categoryToRemove: null,
      deleteAssetCategoryDialog: false,
      editingItem: null,
      indexOfModifiedNode: null,
      indexCategoryToRemove: null,
      indexOfModifiedSubCategory: null,
      search: null,
      modes: {
        add: false,
        edit: false,
        delete: false
      },
      rules: {
        required: [v => !!v || 'Required']
      }
    }
  },
  computed: {
    user () {
      return this.$store.getters.getUser
    },
    show: {
      get () {
        return this.value
      },
      set (val) {
        this.$emit('input', val)
      }
    },
    confirmOrDeniedDialogModes () {
      return this.$store.getters.getConfirmOrDeniedDialogModes
    },
    ifSomeModesOn () {
      return this.modes.add || this.modes.edit || this.modes.delete
    }
  },
  mounted () {
    this.getAssetCategories()
  },
  methods: {
    addNewCategory () {
      if (this.search) {
        this.search = null
      }
      this.modes.add = true
      const newCategory = {
        Item_ID: null,
        Item_Key: new Date().getTime(),
        Name: '',
        Category: true,
        Subcategories: []
      }
      this.editingItem = newCategory
      this.indexOfModifiedNode = this.categoriesTree.length
      this.categoriesTree.push(newCategory)
    },
    addNewSubcategory (item, open, e) {
      if (this.search) {
        this.search = null
      }
      this.modes.add = true
      if (open) {
        e.stopPropagation()
      }
      this.indexOfModifiedNode = this.categoriesTree.findIndex(el => el.Item_ID === item.Item_ID)
      const newSubcategory = {
        Item_ID: null,
        Item_Key: new Date().getTime(),
        Name: '',
        Subcategory: true,
        Category_ID: this.categoriesTree[this.indexOfModifiedNode].Item_ID
      }
      this.editingItem = newSubcategory
      this.indexOfModifiedSubCategory = this.categoriesTree[this.indexOfModifiedNode].Subcategories.length
      this.categoriesTree[this.indexOfModifiedNode].Subcategories.push(newSubcategory)
    },
    editCategory (item) {
      this.modes.edit = true
      this.beforeModifiedItemCopy = { ...item }
      this.editingItem = item
      if (item.Category) {
        this.indexOfModifiedNode = this.categoriesTree.findIndex(el => el.Item_ID === item.Item_ID)
      } else if (item.Subcategory) {
        this.indexOfModifiedNode = this.categoriesTree.findIndex(el => el.Item_ID === item.Category_ID)
        this.indexOfModifiedSubCategory = this.categoriesTree[this.indexOfModifiedNode].Subcategories.findIndex(el => el.Item_ID === item.Item_ID)
      }
    },
    cancelEditing () {
      if (this.modes.add) {
        if (this.editingItem.Category) {
          this.categoriesTree.pop()
        } else if (this.editingItem.Subcategory) {
          this.categoriesTree[this.indexOfModifiedNode].Subcategories.pop()
        }
        this.modes.add = false
      } else if (this.modes.edit) {
        if (this.editingItem.Category) {
          this.categoriesTree[this.indexOfModifiedNode].Name = this.beforeModifiedItemCopy.Name
        } else if (this.editingItem.Subcategory) {
          this.categoriesTree[this.indexOfModifiedNode].Subcategories[this.indexOfModifiedSubCategory].Name = this.beforeModifiedItemCopy.Name
        }
        this.indexOfModifiedSubCategory = null
        this.indexOfModifiedNode = null
        this.beforeModifiedItemCopy = null
        this.modes.edit = false
      }
      this.editingItem = null
    },
    saveItem (item) {
      if (item.Subcategory && !item.Item_ID && this.modes.add) {
        const body = {
          Asset_Subcategory_ID: item.Item_ID,
          Asset_Category_ID: item.Category_ID,
          Subcategory_Name: item.Name
        }
        this.postCategory('/api/asset_subcategory', body)
      } else if (item.Category && !item.Item_ID && this.modes.add) {
        const body = {
          Category_Name: item.Name,
          Subcategories: item.Subcategories
        }
        this.postCategory('/api/asset_category', body)
      } else if (item.Category && item.Item_ID && this.modes.edit) {
        const body = {
          Asset_Category_ID: this.editingItem.Item_ID,
          Category_Name: this.editingItem.Name
        }
        this.updateCategory('/api/asset_category/', body)
      } else if (item.Subcategory && item.Item_ID && this.modes.edit) {
        const body = {
          Asset_Subcategory_ID: this.editingItem.Item_ID,
          Asset_Category_ID: this.editingItem.Category_ID,
          Subcategory_Name: this.editingItem.Name
        }
        this.updateCategory('/api/asset_subcategory/', body)
      }
    },
    showDeleteCategoryDialog (item) {
      if (item.Category) {
        this.indexCategoryToRemove = this.categoriesTree.findIndex(el => el.Item_ID === item.Item_ID)
        this.categoryToRemove = item
      } else {
        this.indexOfModifiedNode = this.categoriesTree.findIndex(el => el.Item_ID === item.Category_ID)
        this.indexCategoryToRemove = this.categoriesTree[this.indexOfModifiedNode].Subcategories.findIndex(el => el.Item_ID === item.Item_ID)
        this.categoryToRemove = item
      }
      this.modes.delete = true
      this.deleteAssetCategoryDialog = true
    },
    cancelDeleting () {
      this.modes.delete = false
      this.categoryToRemove = null
      this.indexCategoryToRemove = null
      this.indexOfModifiedNode = null
    },
    getAssetCategories () {
      this.axios.get('/api/asset_categories', {
        headers: {
          Authorization: 'Bearer ' + this.user.token
        }
      }).then(res => {
        this.categoriesTree = this.generateGroupsOfCategories(res.data[0], res.data[1])
      }).catch(error => {
        this.$store.dispatch('setError', { errorMsg: error.message + ' - ' + error.response.data })
      })
    },
    postCategory (url, item) {
      this.axios.post(url, item, {
        headers: {
          Authorization: 'Bearer ' + this.user.token
        }
      }).then(res => {
        const modifiedCategory = this.categoryModification(res.data[0])
        if (modifiedCategory.Category) {
          this.categoriesTree.splice(this.indexOfModifiedNode, 1, modifiedCategory)
        } else if (modifiedCategory.Subcategory) {
          this.categoriesTree[this.indexOfModifiedNode].Subcategories.splice(this.indexOfModifiedSubCategory, 1, modifiedCategory)
        }

        this.indexOfModifiedSubCategory = null
        this.indexOfModifiedNode = null
        this.editingItem = null
        this.modes.add = false
        this.$store.dispatch('setSuccess', { successMsg: 'Changes successfully added' })
      }).catch(error => {
        this.$store.dispatch('setError', { errorMsg: error.message + ' - ' + error.response.data })
      })
    },
    updateCategory (url, body) {
      this.axios.put(`${url}+${this.editingItem.Item_ID}`, body, {
        headers: {
          Authorization: 'Bearer ' + this.user.token
        }
      }).then(res => {
        this.$store.dispatch('setSuccess', { successMsg: 'Changes successfully updated' })
        this.editingItem = null
        this.indexOfModifiedSubCategory = null
        this.indexOfModifiedNode = null
        this.beforeModifiedItemCopy = null
        this.modes.edit = false
      }).catch(error => {
        this.$store.dispatch('setError', { errorMsg: error.message + ' - ' + error.response.data })
      })
    },
    deleteAssetCategory () {
      let url = ''
      if (this.categoryToRemove.Category) {
        url = '/api/asset_category/'
      } else {
        url = '/api/asset_subcategory/'
      }

      if (this.categoryToRemove && url && this.modes.delete) {
        this.axios.delete(`${url}+${this.categoryToRemove.Item_ID}`, {
          headers: {
            Authorization: 'Bearer ' + this.user.token
          }
        }).then(res => {
          if (this.categoryToRemove.Category) {
            this.categoriesTree.splice(this.indexCategoryToRemove, 1)
          } else {
            this.categoriesTree[this.indexOfModifiedNode].Subcategories.splice(this.indexCategoryToRemove, 1)
          }
          this.$store.dispatch('setSuccess', { successMsg: 'Successfully deleted' })
          this.deleteAssetCategoryDialog = false
          this.cancelDeleting()
        }).catch(error => {
          this.$store.dispatch('setError', {
            errorMsg: error.message + ' - ' + error.response.data
          })
        })
      }
    },
    generateGroupsOfCategories (categories, subcategories) {
      const groupsOfCategories = []
      const categoryMap = {}

      categories.forEach(el => {
        categoryMap[el.Asset_Category_ID] = {
          Item_ID: el.Asset_Category_ID,
          Item_Key: `${el.Asset_Category_ID}_${el.Category_Name}`,
          Name: el.Category_Name,
          Category: true,
          Subcategories: []
        }
      })
      subcategories.forEach(el => {
        if (categoryMap[el.Asset_Category_ID]) {
          categoryMap[el.Asset_Category_ID].Subcategories.push({
            Item_ID: el.Asset_Subcategory_ID,
            Item_Key: `${el.Asset_Subcategory_ID}_${el.Subcategory_Name}`,
            Name: el.Subcategory_Name,
            Subcategory: true,
            Category_ID: el.Asset_Category_ID
          })
        }
      })
      Object.keys(categoryMap).forEach(categoryID => {
        groupsOfCategories.push(categoryMap[categoryID])
      })
      return groupsOfCategories
    },
    categoryModification (category) {
      if (category.Asset_Category_ID && !category.Asset_Subcategory_ID) {
        return {
          Item_ID: category.Asset_Category_ID,
          Item_Key: `${category.Asset_Category_ID}_${category.Category_Name}`,
          Name: category.Category_Name,
          Category: true,
          Subcategories: []
        }
      } else if (category.Asset_Subcategory_ID && category.Asset_Category_ID) {
        return {
          Item_ID: category.Asset_Subcategory_ID,
          Item_Key: `${category.Asset_Subcategory_ID}_${category.Subcategory_Name}`,
          Name: category.Subcategory_Name,
          Subcategory: true,
          Category_ID: category.Asset_Category_ID
        }
      }
    }
  }
}
</script>

<style lang="scss" scoped>
::v-deep {
  .v-dialog {
    height: 800px;
    transform-origin: center center;
  }
  .v-treeview-node__root {
    cursor: pointer;
    position: sticky;
    top: 0;
    background-color: inherit;
    z-index: 2;
  }
  .v-treeview {
    height: 601px;
    overflow-x: auto;
  }
  .v-treeview-node__children {
    .v-treeview-node__root {
      z-index: 0;
    }
  }
}

.sticky-header {
  position: sticky;
  top: 0;
  z-index: 2;
}

.sticky-bottom {
  position: sticky;
  bottom: 0;
  z-index: 2;
  border-top: 1px solid rgba(0, 0, 0, 0.12);
}

.theme--dark {
  .sticky-bottom {
    border-top-color: rgba(255, 255, 255, 0.12);
  }

  ::v-deep {
    .v-treeview-node__root:hover {
      background-color: rgba(255, 255, 255, 0.08);
    }
  }
}
</style>
